import { createRoot, hydrateRoot } from "react-dom/client"
import App from "./app"
import { HelmetProvider } from "react-helmet-async"
import { BrowserRouter } from "react-router-dom"
import { registerPwa } from "@features/pwa/registerPwa"
import { trackEvent } from "@components/utils/tracking.client"

declare global {
  interface Window {
    __INITIAL_DATA__?: {
      isAuthenticated?: boolean
      url?: string
    }
  }
}

const isAuthenticated = window.__INITIAL_DATA__?.isAuthenticated || false
const url = window.__INITIAL_DATA__?.url || "/"

const rootElement = document.getElementById("root")!
const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App isAuthenticated={isAuthenticated} url={url} />
    </BrowserRouter>
  </HelmetProvider>
)

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app)
} else {
  createRoot(rootElement).render(app)
}

registerPwa()

document.addEventListener("click", (event) => {
  const target = event.target as Element | null
  const link = target?.closest("a")
  const href = link?.getAttribute("href") || ""
  if (href.startsWith("tel:")) {
    trackEvent("phone_click", { page_path: window.location.pathname })
  } else if (href.startsWith("mailto:")) {
    trackEvent("email_click", { page_path: window.location.pathname })
  } else if (["/faire-une-demande", "/nous-contacter", "/demande-de-location"].includes(href)) {
    trackEvent("primary_cta_click", { page_path: window.location.pathname, destination: href })
  }
})

// 2) Then, if we want partial hydration for a subcomponent
//    we can do so conditionally or always:
// partialHydrate()
